export default [
  {
    title: 'Gestión',
    items: [
      {
        type: 'group',
        name: 'Presupuestos',
        id: 'presupuestos',
        icon: 'wallet',
        items: [
          { name: 'Dashboard', to: '/reporte/dashboard' },
          { name: 'Listado', to: '/presupuestos/list' },
          { name: 'Asignación', to: '/presupuestos/asignado' },
        ],
      },
      {
        type: 'group',
        name: 'Proyectos',
        id: 'proyecto',
        icon: 'briefcase',
        items: [
          { name: 'Tratos', to: '/proyecto/trato' },
          { name: 'Gestión', to: '/proyecto/gestion' },
          { name: 'Factura', to: '/proyecto/factura' },
        ],
      },
    ],
  },
  {
    title: 'Comercial',
    items: [
      // {
      //   type: 'group',
      //   name: 'Cotización',
      //   id: 'cotizacion',
      //   icon: 'wallet',
      //   items: [
      //     { name: 'Perfil Profesional', to: '/cotizacion/perfilProfesional' },
      //     { name: 'Tareas', to: '/cotizacion/tareas' },
      //     { name: 'Cotizaciones', to: '/cotizacion/listado' },
      //     { name: 'Cotización IA', to: '/cotizacion/cotizacionIA' },
      //     { name: 'Outsourcing', to: '/cotizacion/outsourcing/list' },
      //   ],
      // },
      {
        type: 'group',
        name: 'Monitor Comercial',
        id: 'checklist',
        icon: 'activity',
        items: [
          { name: 'Dashboard', to: '/checklist/dashboard' },
          { name: 'Oportunidades', to: '/checklist' },
        ],
      },
    ],
  },
  {
    title: 'Reportes',
    items: [
      {
        type: 'link',
        name: 'Facturación',
        id: 'reporte/facturacion',
        icon: 'bill',
        to: '/reporte/facturacion',
      },
    ],
  },
  {
    title: 'Cumplimiento',
    items: [
      {
        type: 'link',
        name: 'Salidas no conformes',
        id: 'noconformidades/list',
        icon: 'clipboardx',
        to: '/cumplimiento/noconformidades/list',
      },
    ],
  },
  {
    title: 'Administración',
    items: [
      {
        type: 'group',
        name: 'Mantenedores',
        id: 'mantenedores',
        icon: 'monitor',
        items: [
          { name: 'Área', to: '/mantenedores/area' },
          // { name: 'Clientes', to: '/mantenedores/clientes' },
          { name: 'Líneas de gastos', to: '/mantenedores/lineaGasto' },
          { name: 'Hitos', to: '/mantenedores/hito' },
          { name: 'Tipo documento', to: '/mantenedores/tipoDocumento' },
          // { name: 'Costo Empresa', to: '/mantenedores/costoEmpresa' },
          // { name: 'Costo Extra', to: '/mantenedores/costoExtra' },
          { name: 'Listado de SNC', to: '/mantenedores/snc' },
        ],
      },
      {
        type: 'group',
        name: 'Configuración',
        id: 'configuracion',
        icon: 'settings',
        items: [
          { name: 'Notificaciones', to: '/configuracion/tipoNotificacion' },
          { name: 'Mensajería', to: '/configuracion/mensajeria' },
        ],
      },
      {
        type: 'group',
        name: 'Permisos',
        id: 'permisos',
        icon: 'users',
        items: [
          { name: 'Usuarios', to: '/permisos/usuarios' },
          { name: 'Perfiles', to: '/permisos/perfil' },
        ],
      },
    ],
  },
]
